var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/nav-button/MainNavButton.tsx",
  _this = this;
import React, { useContext } from 'react';
import { createURL, getClientEnvironmentDetails } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { generateMetricsAttribute } from '@sm/metrics';
import { NavButton } from './NavButton';
import HeaderContext from '../../HeaderContext';
var MainNavButton = function MainNavButton(_ref) {
  var children = _ref.children,
    href = _ref.href,
    label = _ref.label,
    active = _ref.active,
    navItem = _ref.navItem,
    target = _ref.target;
  var url = href && createURL(href, {
    ut_source: 'header'
  });
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isNode = _getClientEnvironment.isNode;
  var currentPath = !isNode ? document.location.pathname : '';
  var pattern = new RegExp("^".concat(currentPath, "/?$"));
  var match = href ? pattern.test(href) : false;
  var isActive = active || match;
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var metricsData = generateMetricsAttribute({
    data: {
      url: pageURL,
      pageName: pageName,
      amplitudeEvent: 'header clicked navigation',
      navItem: navItem
    }
  });
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement("li", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(NavButton, {
      href: navItem === 'data studio' ? href : url,
      label: label,
      active: isActive,
      "data-sm-metrics": metricsData,
      target: target,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 13
      }
    }, children || label)) : /*#__PURE__*/React.createElement(List.Item, {
      isNavigable: true,
      href: navItem === 'data studio' ? href : url,
      "data-sm-metrics": metricsData,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 11
      }
    }, children || label);
  });
};
export default MainNavButton;
export { MainNavButton };
//# sourceMappingURL=MainNavButton.js.map